module.exports = "<p>\n  sso-signup-response works!\n</p>\n<span>Welcome</span>"


//////////////////
// WEBPACK FOOTER
// ./src/app/feature/sso-signup-response/sso-signup-response.component.html
// module id = ./src/app/feature/sso-signup-response/sso-signup-response.component.html
// module chunks = main